import { qs } from '../../assets/js/src/scripts.js';
// import { galaxoStats } from '../../../src/assets/js/src/scripts-galaxo.js';

var locations = [
	{
		'name': 'Kesakatu_kauppurienkatu_kesakatu',
		'floor': '1',
		'department': 'Valkea'
	},
];


function init(store) {

	var $locationTrigger = $('.my-location-trigger');

	if (!$locationTrigger.length) {
		return;
	}

	$(document).on('located', function(e, screenLocation) {

		if (screenLocation.name === 'K2') {
			return;
		}

		// Enable "My location" button
		//$locationTrigger.addClass('is-active').attr('href', `${$locationTrigger.attr('href')}#location=${screenLocation.name}`);
		$locationTrigger.addClass('is-active').attr('href', `${$locationTrigger.attr('href')}#location=${'Kesakatu_kauppurienkatu_kesakatu'}`);

		// Handle "My location" click
		$locationTrigger.on('mousedown', function(event) {

			var params = qs.parse(this.href && this.href.split('#')[1]);

			event.preventDefault();

			if ($(document.body).is('.tpl-map')) {

				//galaxoStats.send('my_location', $('title').data('page-title'));

				console.log(params.location);

				store.dispatch({
					type: 'SELECT_LOCATION',
					locationName: params.location
				});

			} else {

				document.location.href = $locationTrigger.attr('href');
			}

		});

	});

	$locationTrigger.on('click', function(event) {
		event.preventDefault();
	});

	// Request location from infoscreen-device (triggers the `located` event on success)
	getLocation();

}

function getLocation(requestedLocation) {

	// var randomLocation = locations[Math.floor(Math.random() * locations.length)];
	var urlParams = qs.parse(
			window.location.search && window.location.search.replace('?', '')
			|| window.location.hash && window.location.hash.replace('#', '')
		);

	var predefinedLocation = urlParams.location || requestedLocation;

	var location = "Kesakatu_kauppurienkatu_kesakatu";

	if (location) {
		$(document).trigger('located', location);
	}

	return location;

	/*
	return $.get('/f_248/content_tag.php')
		.then(
			function(response) {

				var locationName = predefinedLocation || response;
				var location = locations.find(location => location.name === locationName);

				location = "Kesakatu_kauppurienkatu_kesakatu"

				if (location) {
					$(document).trigger('located', location);
				}

				return location;
			}
		);
		*/

}

export default {
	init
};
